import { useEffect, useState } from 'react'
import axios from 'axios'
import { getConfig } from '../config/getConfig'
import Spotify from '../images/svg/Spotify'
import Applemusic from '../images/svg/Applemusic'
import Youtube from '../images/svg/Youtube'
import Amazon from '../images/svg/Amazon'
import AmazonMusic from '../images/svg/AmazonMusic'
import Anghami from '../images/svg/Anghami'
import Boomplay from '../images/svg/Boomplay'
import Deezer from '../images/svg/Deezer'
import Itunes from '../images/svg/Itunes'
import Pandora from '../images/svg/Pandora'
import Tidal from '../images/svg/Tidal'
import YoutubeMusic from '../images/svg/YoutubeMusic'
import backgroundImage from '../images/BlurTriggered.webp'
import '../singles.css'
const config = getConfig()

const link = {
    id: 'triggered',
    title: 'TRIGGERED - OUT NOW!',
    band_name: 'Her Last Sight',
    song_name: 'TRIGGERED',
    type: 'multi',
    links: {
        spotify: "https://open.spotify.com/album/19vCDVW34x0PLy9XhMwKMa",
        applemusic: "https://music.apple.com/album/triggered/1794599814",
        youtube: "https://www.youtube.com/watch?v=fWKCrUrYpHk",
        youtubemusic: "https://music.youtube.com/watch?v=jXTCwcFPv2s",
        deezer: "https://www.deezer.com/us/track/3214306211",
        // itunes: "",
        tidal: "https://tidal.com/browse/album/415327115",
        // amazon: "",
        // amazonmusic:"",
        // boomplay: '',
        // pandora: '',
        // anghami: '',
    },
    image: "https://res.cloudinary.com/dpwavn5n8/image/upload/v1741129832/r31rgzphl6qlq5nmhtxg.webp",
}

export default function SingleTriggered() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsObject = {};
    for (let [key, value] of urlParams) { paramsObject[key] = value; }

    const queryString = [...urlParams].map(([key, value]) => `${key}=${value}`).join('&');

    async function countVisitors() {
        try {
            // axios.get(`${config.backend}/countVisitors?o=${paramsObject.o}&p=serenity`)
            axios.get(`${config.backend}/e/view?${queryString}`)
        } catch (error) { }
    }

    async function sendClick(event, data, platform = null) {
        event.preventDefault();

        const dataCopy = JSON.parse(JSON.stringify(data))
        try {
            if (data.type === 'multi') {
                dataCopy.link = data.links[platform]
                delete dataCopy.links
                dataCopy.platform = platform
            }
            const body = { ...paramsObject, clicked_link: encodeURIComponent(dataCopy.link), platform: dataCopy.platform }
            let queryString_click = ""
            Object.keys(body).forEach(key => { queryString_click += key + '=' + body[key] + "&" })
            queryString_click = queryString_click.slice(0, queryString_click.length - 1)
            await axios.get(`${config.backend}/e/click?${queryString_click}`)
        } catch (error) { }
        finally {
            window.location.href = data.links[platform];
        }
    }

    useEffect(() => {
        countVisitors()
    }, [])

    return (<div className='bg_full_single' style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', zIndex: 0 }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100dvh', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 2 }} />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1vh', marginBottom: '3vh', zIndex: 999 }}>
            <img src="https://static.wixstatic.com/media/b59144_9ede0b40946b43e68439cb4a5b18ccf1~mv2.png/v1/fill/w_775,h_189,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/LOGO%20STRAIGHT_edited.png" style={{ maxWidth: "80%", height: 'auto' }} alt="" />
            <span className='single_name' style={{ color: 'white' }}>{link.song_name.toUpperCase()}</span>
        </div>

        {Object.keys(link.links).map(platform => <a style={{ zIndex: 999 }} className="singleLink_single" onClick={e => { sendClick(e, link, platform) }} href={link.links[platform]}>
            {getPlatformLogo(platform, 45, 45)}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', zIndex: 999 }}>
                <div style={{ marginLeft: '-7%' }}>{getPrettyName(platform)}</div>
            </div>
        </a>)}

        <footer style={{ zIndex: 999 }}>
            Her Last Sight 2026 ©
        </footer>
    </div>)
}

function getPlatformLogo(platform, width, height) {
    switch (platform) {
        case 'amazonmusic':
            return <AmazonMusic width={width} height={height} />
        case 'amazon':
            return <Amazon width={width} height={height} />
        case 'anghami':
            return <Anghami width={width} height={height} />
        case 'applemusic':
            return <Applemusic width={width} height={height} />
        case 'boomplay':
            return <Boomplay width={width} height={height} />
        case 'deezer':
            return <Deezer width={width} height={height} />
        case 'itunes':
            return <Itunes width={width} height={height} />
        case 'pandora':
            return <Pandora width={width} height={height} />
        case 'spotify':
            return <Spotify width={width} height={height} />
        case 'tidal':
            return <Tidal width={width} height={height} />
        case 'youtubemusic':
            return <YoutubeMusic width={width} height={height} />
        case 'youtube':
            return <Youtube width={width} height={height} />
        default:
            return ""
    }
}
function getPrettyName(platform) {
    switch (platform) {
        case 'amazonmusic':
            return "Amazon Music"
        case 'amazon':
            return "Amazon"
        case 'anghami':
            return "Anghami"
        case 'applemusic':
            return "Apple Music"
        case 'boomplay':
            return "Boomplay"
        case 'deezer':
            return "Deezer"
        case 'itunes':
            return "iTunes"
        case 'pandora':
            return "Pandora"
        case 'spotify':
            return "Spotify"
        case 'tidal':
            return "Tidal"
        case 'youtubemusic':
            return "YouTube Music"
        case 'youtube':
            return "YouTube"
        default:
            return ""
    }
}